import { ApolloQueryResult } from 'apollo-client';

import {
    getValueFromApiFormat,
    mapAdditionalFilterToApiFormat,
    mapSortParamsToString,
    mapTotalStatsToApiFormat
} from '../../mappers/common/common';
import { mapGroupFilterToApiFormat, mapRowsToGroups } from '../../mappers/group/group';
import { getDefaultSort } from '../../service/GridHelpers/GridHelpers';
import { ClientInfo } from '../../typings/common';
import { GroupsQuery, GroupsSuggestQuery } from '../../typings/graphql-grid';
import { defaultClientInfo, GridParams, GridSourceParams } from '../../typings/grid';

import { mapGridParamsToStatRequirements } from './common';

export const mapSourceParamsToGroupsAndSuggestQueryVariables = (params: GridParams, clientInfo: ClientInfo) => {
    const { sortParams, filter, view, additionalFilter, alertMessageFilter, campaignsCalcTypeFilter } = params;

    let apiFormatFilter;

    if (params.messageType && alertMessageFilter) {
        apiFormatFilter = mapGroupFilterToApiFormat(alertMessageFilter, clientInfo, campaignsCalcTypeFilter);
    } else if (filter) {
        apiFormatFilter = mapGroupFilterToApiFormat(filter, clientInfo, campaignsCalcTypeFilter);
    } else {
        apiFormatFilter = {};
    }

    if (additionalFilter !== undefined) {
        apiFormatFilter.archived = mapAdditionalFilterToApiFormat(additionalFilter);
    }

    return {
        orderBy: sortParams ? mapSortParamsToString(sortParams) : getDefaultSort(view),
        statRequirements: mapGridParamsToStatRequirements(params),
        filter: {
            ...((filter || additionalFilter) && apiFormatFilter),
            campaignIdIn: params.campaignsIds
        }
    };
};

export const mapGroupQueryResultToEntitiesQueryResponse = (
    result: ApolloQueryResult<GroupsQuery>,
    params: GridSourceParams
) => {
    const { client, reqId } = result.data;
    const {
        adGroups: groupsResult,
        features,
        info: { workCurrency, countryRegionId }
    } = client;

    const { rowset: groupsRows, totalCount, adGroupIds, cacheKey, totalStats } = groupsResult;

    const { cost, clicks, shows, ctr } = totalStats;

    return {
        data: {
            data: mapRowsToGroups(groupsRows, client, params),
            total: totalCount,
            cacheKey: getValueFromApiFormat(cacheKey),
            allItemsIds: adGroupIds.map(String)
        },
        clientInfo: {
            ...defaultClientInfo,
            ...features,
            workCurrency,
            countryRegionId
        },
        totalStats: mapTotalStatsToApiFormat({
            cost,
            clicks,
            shows,
            ctr
        }),
        hasObjectsOverLimit: groupsResult.features.hasAdGroupsOverLimit,
        reqId
    };
};

export const mapGroupSuggestQueryResultToSuggestQueryResponse = (result: ApolloQueryResult<GroupsSuggestQuery>) => {
    return {
        data: result.data.client.adGroups.rowset.map(item => item.name),
        reqId: result.data.reqId
    };
};
